import { VOImage, VOImageAnimation } from "../../model/DataStructure.js";

export abstract class AbstractImageItem<Element> {
    public element: Element;

    private _x: number = -1;
    private _hidden: boolean = false;
    private _ax: number = 0;
    private _ay: number = 0;
    private _ascale:number = 1;
    private _animation: gsap.core.Tween = null;

    constructor(public image: VOImage, public screenWidth: number) {
        this.createElement(image);

        if (image.animation && image.animation !== "none") {
            this.setAnimation(image.animation);
        }
    }

    protected setAnimation(animation: VOImageAnimation): void {
        this.killAnimation();
        this._ax = 0;
        this._ay = 0;

        if (animation === "hover") {
            this._animation = gsap.to(this, {
                duration: 4,
                _ay: -40,
                yoyo: true,
                ease: "power2.inOut",
                repeat: -1,
                onUpdate: () => this.updateTransform()
            });
        }
    }

    protected killAnimation(): void {
        if (this._animation)
            this._animation.kill();
        this._animation = null;
    }

    public get width(): number {
        return this.image.image.width;
    }

    public get height(): number {
        return this.image.image.height;
    }

    public get z(): number {
        return this.image.z;
    }

    public get top(): number {
        return this.image.y;
    }

    public get bottom(): number {
        return this.top + this.height;
    }

    public get right(): number {
        return this.left + this.width;
    }

    public get left(): number {
        return this.image.x;
    }

    protected abstract createElement(image: VOImage): void;
    protected abstract setVisibility(visible: boolean): void;
    protected abstract setTransform(x: number, y: number, scale:number): void;

    public get hidden(): boolean {
        return this._hidden;
    }

    public set hidden(hidden: boolean) {
        if (this._hidden === hidden)
            return;
        this._hidden = hidden;
        this.setVisibility(!hidden);
    }

    public get x(): number {
        return this._x;
    }

    public set x(x: number) {
        if (this._x === x)
            return;
        this._x = x;
        this.updateTransform();
    }

    private updateTransform(): void {
        var x = this._x + this._ax;
        this.hidden = x + (this.width * this._ascale) < 0 || x > this.screenWidth;
        if (this.hidden)
            return;
        this.setTransform(x, this.top + this._ay, this._ascale);
    }
}